export class LoginPage {
    static EventListeners = {
        'ShoptetDOMPageContentLoaded': LoginPage.doLoadOnShoptetDOMPageContentLoaded,
    }
    static doLoadOnShoptetDOMPageContentLoaded() {}
    static doLoadOnShoptetDOMPageMoreProductsLoaded() {}
    static doLoadOnShoptetDOMContentLoaded() {}
    static doLoadOnChange() {}
    static async doInit() {
        LoginPage.doStyleMisc();
        return true;
    }

    static doStyleMisc() {
        $('body').addClass('in-login');
    }
}
